import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-driver-license-declined',
    templateUrl: './driver-license-declined.component.html',
    styleUrls: ['./driver-license-declined.component.css']
})
export class DriverLicenseDeclinedComponent implements OnInit {
    @Input() processStatus: any = '';

    constructor() { }

    ngOnInit() {
    }

}
